export { CardMiniDesktop } from "./CardMiniDesktop";
